export type ContactFormData = {
  name: string
  email: string
  message: string
}

// Returns error string or undefined — fits tanstack form validators.onChange
export const contactValidators = {
  name(value: string): string | undefined {
    if (value.length < 2) return "Name must be at least 2 characters"
    if (value.length > 100) return "Name must be less than 100 characters"
    return undefined
  },
  email(value: string): string | undefined {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "Please enter a valid email address"
    if (value.length > 255) return "Email must be less than 255 characters"
    return undefined
  },
  message(value: string): string | undefined {
    if (value.length < 10) return "Message must be at least 10 characters"
    if (value.length > 2000) return "Message must be less than 2000 characters"
    return undefined
  },
}

type ValidationError = { field: string; message: string }

export function parseContactForm(
  data: unknown
): { success: true; data: ContactFormData } | { success: false; errors: ValidationError[] } {
  if (!data || typeof data !== "object") {
    return { success: false, errors: [{ field: "", message: "Invalid request body" }] }
  }

  const { name, email, message } = data as Record<string, unknown>
  const errors: ValidationError[] = []

  if (typeof name !== "string") {
    errors.push({ field: "name", message: "Name is required" })
  } else {
    const err = contactValidators.name(name)
    if (err) errors.push({ field: "name", message: err })
  }

  if (typeof email !== "string") {
    errors.push({ field: "email", message: "Email is required" })
  } else {
    const err = contactValidators.email(email)
    if (err) errors.push({ field: "email", message: err })
  }

  if (typeof message !== "string") {
    errors.push({ field: "message", message: "Message is required" })
  } else {
    const err = contactValidators.message(message)
    if (err) errors.push({ field: "message", message: err })
  }

  if (errors.length > 0) return { success: false, errors }

  return {
    success: true,
    data: { name: name as string, email: email as string, message: message as string },
  }
}
